"use client";

import { SignUpStep } from "@/components/onboarding/signup-step";
import { useRouter } from "next/navigation";

export function CreateAccountPageClient() {
  const router = useRouter();

  return (
    <SignUpStep onSignUp={() => router.push("/getting-started/verify-email")} />
  );
}
